import styles from './FJMobileTextToImageStyleList.module.less';
import FJHorizontalScroller from '../../../common/components/FJScroller/FJHorizontalScroller';
import classNames from 'classnames';
import { useRef, useMemo, useState, useEffect } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import PropTypes from 'prop-types';
import { useCallback } from 'react';

let scrollTimer = null;
const FJMobileTextToImageStyleList = props => {
    const { list = [], onChangeStyle, curStyle } = props;
    const [selectStyleCategory, setSelectStyleCategory] = useState(0);
    const categoryScrollRef = useRef(null);
    const styleScrollRef = useRef(null);
    const isScrollingRef = useRef(false);

    const categoryList = useMemo(() => {
        return list.map(item => item.categoryName);
    }, [list]);
    const styleItemList = useMemo(() => {
        if (!list) return [];
        return list.reduce((acc, cur) => {
            return [...acc, ...cur.list];
        }, []);
    }, [list]);
    // 分类切换自动居中滚动
    const _onCategoryAutoScroll = useCallback(() => {
        if (categoryScrollRef.current) {
            const children = _getScrollChildren(categoryScrollRef);
            const containerWidth = categoryScrollRef.current.getScroller().offsetWidth;
            const selectItem = children[selectStyleCategory];
            if (selectItem) {
                const childrenWidth = (selectItem && selectItem.offsetWidth) || 0;
                const scrollLeft = selectItem.offsetLeft - (containerWidth - childrenWidth) / 2;
                _scroll(categoryScrollRef, scrollLeft);
            }
        }
    }, [selectStyleCategory]);
    useEffect(() => {
        _onCategoryAutoScroll();
    }, [selectStyleCategory, _onCategoryAutoScroll]);
    const _scroll = (scrollRef, left) => {
        if (scrollRef.current) {
            scrollRef.current.scrollToLeft(left, 'smooth');
        }
    };
    const _getScrollChildren = ref => {
        return ref.current && ref.current.getScroller().children;
    };
    const _getStyleIndex = styleName => {
        if (!styleName) {
            return 0;
        }
        let isFind = false;
        // 当前分类前面的元素个数
        return list.reduce((calc, cur) => {
            const index = cur.list.findIndex(i => i.name === styleName);
            if (index !== -1) {
                isFind = true;
                return index + calc;
            } else if (!isFind) {
                return calc + cur.list.length;
            } else {
                return calc;
            }
        }, 0);
    };

    const _getStyleOffsetLeft = index => {
        // 16 + 80 + 6 = 102； 98 + 6 = 104；  元素间距:6
        if (index === 0) {
            return 16;
        } else {
            return 102 + 104 * (index - 1);
        }
    };
    // 滚动到选中元素且居中
    const _scrollToSelectMiddle = selectStyle => {
        if (styleScrollRef.current) {
            const item = selectStyle || curStyle;
            const count = _getStyleIndex(item.name);
            const containerWidth = styleScrollRef.current.getScroller().offsetWidth;
            // ios 系统获取元素宽度有问题
            // const children = _getScrollChildren(styleScrollRef);
            // const childrenWidth = children[count].getBoundingClientRect().width;
            // const scrollLeft = children[count].offsetLeft - 16 - containerWidth / 2 + childrenWidth / 2;

            // 第一个元素宽度80 其余 98 (下下策)
            const childrenWidth = count === 0 ? 80 : 98;

            const offsetLeft = _getStyleOffsetLeft(count);
            const scrollLeft = offsetLeft - 16 - containerWidth / 2 + childrenWidth / 2;
            _scroll(styleScrollRef, scrollLeft);
        }
    };
    const _onCategoryTabChange = index => {
        if (index === selectStyleCategory) {
            return;
        }
        setSelectStyleCategory(index);
        if (styleScrollRef.current) {
            // 当前分类前面的元素个数
            const itemIdx = list.reduce((calc, cur, idx) => calc + (index > idx ? cur.list.length : 0), 0);

            // 判断是选中分类是否有选中元素
            const selectStyleIdx = list[index].list.findIndex(i => i.name === curStyle.name);
            if (selectStyleIdx !== -1) {
                _scrollToSelectMiddle();
            } else {
                isScrollingRef.current = true;
                let scrollLeft = _getStyleOffsetLeft(itemIdx) - 16;
                _scroll(styleScrollRef, scrollLeft);
            }
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(() => {
                isScrollingRef.current = false;
            }, 1000);
        }
    };

    const _onScroll = () => {
        if (styleScrollRef.current && !isScrollingRef.current) {
            const container = styleScrollRef.current.getScroller();
            const scrollLeft = container.scrollLeft;
            const offsetWidth = container.offsetWidth;
            const children = _getScrollChildren(styleScrollRef);
            let categoryIdx = 0;
            // 判断当前选中是否在可视界面
            const selectStyleIdx = _getStyleIndex(curStyle.name);
            if (
                children[selectStyleIdx] &&
                scrollLeft <= children[selectStyleIdx].offsetLeft &&
                scrollLeft + offsetWidth >= children[selectStyleIdx].offsetLeft
            ) {
                categoryIdx = list.findIndex(item => item.list.findIndex(i => i.name === curStyle.name) !== -1);
            } else {
                for (let i = 0; i < list.length; i++) {
                    const num = list.reduce((calc, cur, idx) => calc + (i >= idx ? cur.list.length : 0), 0);
                    const nextChildDom = children[num];
                    //判断前分类最后一个元素的位置
                    if (nextChildDom && scrollLeft > nextChildDom.offsetLeft - 20) {
                        categoryIdx = i + 1;
                    } else {
                        break;
                    }
                }
            }
            setSelectStyleCategory(categoryIdx);
        }
    };
    const _onSelectStyle = styleObj => {
        onChangeStyle(styleObj);
        _onCategoryAutoScroll();
        _scrollToSelectMiddle(styleObj);
    };
    return (
        <div className={styles.style_box}>
            <FJHorizontalScroller className={styles.category_box} ref={categoryScrollRef}>
                {categoryList.map((item, index) => {
                    return (
                        <div
                            key={item}
                            className={classNames(
                                styles.category_item,
                                selectStyleCategory === index ? styles.active : '',
                            )}
                            onClick={() => _onCategoryTabChange(index)}
                        >
                            {FJLocalStore._(item)}
                        </div>
                    );
                })}
            </FJHorizontalScroller>
            <FJHorizontalScroller
                ref={styleScrollRef}
                className={styles.style_list_box}
                onScroll={_onScroll}
                dependArr={[curStyle, list]}
            >
                {styleItemList.map((item, idx) => {
                    return (
                        <FJHoverBoardGradation
                            onClick={() => _onSelectStyle(item)}
                            key={item.name + idx}
                            className={classNames(styles.style_item, {
                                [styles.none_style_box]: item.value === '',
                            })}
                            contentClassName={classNames(
                                styles.style_item_box,
                                item.value === '' ? styles.style_item_content : '',
                            )}
                            isShowInBorder={item.value !== ''}
                            active={item.name === curStyle.name}
                        >
                            {item.value === '' ? (
                                <img src={item.previewImg} className={styles.none_style_image} />
                            ) : (
                                <>
                                    <img src={item.previewImg} />
                                    <div className={styles.style_item_name_box}>
                                        <span className={styles.style_item_name}>{FJLocalStore._(item.name)}</span>
                                    </div>
                                </>
                            )}
                        </FJHoverBoardGradation>
                    );
                })}
            </FJHorizontalScroller>
        </div>
    );
};
FJMobileTextToImageStyleList.propTypes = {
    curStyle: PropTypes.object,
    onChangeStyle: PropTypes.func,
    list: PropTypes.array,
};

export default FJMobileTextToImageStyleList;
